import { render } from "./open-github-pages-vue.vue?vue&type=template&id=7ca36b4b"
import script from "./open-github-pages-vue.vue?vue&type=script&lang=js"
export * from "./open-github-pages-vue.vue?vue&type=script&lang=js"

import "./open-github-pages-vue.vue?vue&type=style&index=0&id=7ca36b4b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__